import React, { FC, ReactNode } from "react";
import { createPortal } from "react-dom";

interface ModalProps {
  children: ReactNode;
  isOpen: boolean;
  onClose?: () => void;
  /** Tailwind classes that override the default 416px-wide card sizing. */
  panelClassName?: string;
}

const Modal: FC<ModalProps> = ({
  children,
  isOpen,
  onClose,
  panelClassName,
}) => {
  const rootDiv = document.querySelector("#root");
  return (
    <>
      {rootDiv &&
        isOpen &&
        createPortal(
          <div
            className="fixed top-0 left-0 w-screen h-screen z-[9999999991] bg-black bg-opacity-75"
            onClick={onClose}
          >
            <div
              className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-themed-card text-themed-text ${
                panelClassName ?? "w-[416px] px-[32px] pt-[32px] pb-[24px]"
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              {children}
            </div>
          </div>,
          rootDiv
        )}
    </>
  );
};

export default Modal;
